module.exports = __webpack_public_path__ + "static/media/ic-brand.c5016037.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ic-brand.svg
// module id = 791
// module chunks = 0